export class ProcessoObservacao {

  public Id: number;
  public Observacao: string;
  public Ativo: boolean;
  constructor() {
    this.Id = 0;
    this.Observacao = '';
  }
}
